module.exports = __webpack_public_path__ + "static/img/KADE-DE-LA-RUE.d670f09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KADE-DE-LA-RUE.jpg
// module id = 6u4s
// module chunks = 0